export default function assignHOCProps(
    HOC,
    { displayName, propTypes = {}, defaultProps = {}, enumProps = {} },
) {
    const Component = HOC;

    Component.displayName = displayName;
    Component.propTypes = { ...propTypes };
    Component.defaultProps = { ...defaultProps };

    Object.keys(enumProps).forEach((key) => {
        if (!Component[key]) {
            Component[key] = enumProps[key];
        }
    });

    return Component;
}
